import React from 'react';
import { Box, Typography, Link } from '@mui/material';

function Footer() {
  return (
    <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto' }}>
      <Typography variant="body2" color="text.secondary" align="center">
        © {new Date().getFullYear()} Wagl. All rights reserved.
        {' | '}
        <Link color="inherit" href="/terms">
          Terms
        </Link>
        {' | '}
        <Link color="inherit" href="/privacy">
          Privacy
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
